import React, { Component } from 'react';
import { Clouds } from './Clouds'
import { Hamburger } from './Hamburger'
import { BoxenRow } from './BoxenRow'
import { BottomClouds } from './BottomClouds'

import { FutoSpec } from './FutoSpec'
import { MobilePrism } from './MobilePrism'
import { ReactHydrazine } from './ReactHydrazine'
import { Management } from './Management'

import '../css/fonts.css';
import '../css/addlightness.css';

import oaklandSkyline from '../img/oakland-800.png'


export class FrontPage extends Component {
  constructor(props) {
    super(props)

    this.state = {
    }

  }


  render() {

    const reactiveAlFontSize = window.innerWidth < 506 ? '80px' : '138px'
    //const reactiveAlTop = window.innerWidth < 506 ? '90px' : ''

    let alHeaderStyle = {
      //fontFamily: 'BeyondInfinity',
      fontFamily: 'SuperCartoon',
      fontSize: reactiveAlFontSize,
      color: `rgba(31, 85, 125, 1)`,
      //color: 'yellow',
      textShadow: `0 0 6px #1F557D`,
      position: 'absolute',
      marginTop: '150px',
    }

    const reactiveBulletSize = window.innerWidth < 506 ? '20px' : '28px'
    const reactiveBulletMarginTop = window.innerWidth < 506 ? '250px' : '300px'

    let bulletStyle = {
      fontFamily: "Geo Sans Light Oblique",
      fontWeight: 700,
      fontSize: reactiveBulletSize,
      marginTop: reactiveBulletMarginTop,
      color: '#1f557d',
      position: 'absolute',
    }

    const reactiveChapmanFontSize = window.innerWidth < 506 ? '12px' : '16px'
    const reactiveChapmanInnerFontSize = window.innerWidth < 506 ? '8px' : '12px'
    //const topOffset = window.innerHeight - 120
    const topOffset = 700

    let chapmanContainerStyle = {
      position: 'absolute',
      top: `${topOffset}px`,
      fontFamily: 'Geometos',

    }

    let chapmanQuoteStyle = {
      fontSize: reactiveChapmanFontSize,
      color: `rgba(31, 85, 125, ${this.state.opacity})`,
      //textShadow: `0 0 ${this.state.shadowPx}px #1F557D`,
    }

    let chapmanNameStyle = {
      fontSize: reactiveChapmanInnerFontSize,
      color: `rgba(31, 85, 125, ${this.state.opacity})`,
      marginTop: '10px',
      marginLeft: '200px',
      //textShadow: `0 0 ${this.state.shadowPx}px #1F557D`,
    }

    const skylineTop = this.SKYLINE_TOP_OFFSET
    const skylineWidth = window.innerWidth > 506 ? 700 : window.innerWidth

    const skylineContainerStyle = {
      position: 'absolute',
      top: `${skylineTop}px`,
    }

    const sunDim = window.innerWidth > 506 ? 170 : 70
    const sunTop = window.innerWidth > 506 ? skylineTop - 90 : skylineTop - 50
    const sunRight = window.innerWidth > 506 ? 150 : 50
    //const sunColor = '#fefe75'
    //const sunColor = '#f5f569'
    //const sunColor = '#f5f59a'
    //const sunColor = '#fafa91'
    //const sunColor = '#f7f7a8'
    const sunColor = '#fcfc92'

    const yellowSunStyle = {
      position: 'absolute',
      //border: `2px solid ${sunColor}`,
      border: `2px solid grey`,
      background: sunColor,
      borderRadius: '50%',
      height: `${sunDim}px`,
      width: `${sunDim}px`,
      top: sunTop,
      right: `${sunRight}px`,
    }

    const bottomCloudsTopOffset = skylineTop - 200
    const middleListTopOffset = skylineTop / 2 - 400

    const middleListContainerStyle = {
      position: 'absolute',
      top: `${middleListTopOffset}px`,
      width: '50%',
      display: 'flex',
      flexDirection: 'column',
    }

    const fontSize = 24

    const boxStyle = {
      //position: 'absolute',
      border: "2px solid #1F557D",
      borderRadius: '6px',
      boxShadow: "0px 2px 2px rgba(0, 0, 0, 0.1)",
      background: "#ffffff",
      //fontFamily: "BeyondInfinity",
      fontFamily: 'Geo Sans Light Oblique',
      fontSize: `${fontSize}px`,
      padding: "10px",
      //paddingTop: "15px",
      marginLeft: "5px",
      marginRight: "5px",
    }

    const firstIdeaStyle = Object.assign({
      //background: 'Powder Blue',
      fontFamily: 'Geo Sans Light Oblique',
      left: '-300px',
    }, boxStyle)

    const secondIdeaStyle = Object.assign({
      background: 'lightgreen',
      //left: '-75px',
      left: '-300px',
      top: '200px',
      width: '105px',
    }, boxStyle)

    const thirdIdeaStyle = Object.assign({
      background: 'pink',
      //left: '75px',
      left: '-300px',
      top: '400px',
      width: '120px',
    }, boxStyle)





    return (
      <div className="App">

        <div className="center-container">

          <div className='center-container'>
            <p style={alHeaderStyle}>
              Gridiron Football Legends
            </p>
          </div>


        </div>

      </div>
    )
  }
}
